import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/JobCard.css";

const JobCard = ({ job }) => {
  const [saved, setSaved] = useState(false);

  const toggleSaveJob = () => {
    setSaved(!saved);
  };

  const getPostedTime = (date) => {
    const postedDate = new Date(date);
    const now = new Date();
    const diffInDays = Math.floor((now - postedDate) / (1000 * 60 * 60 * 24));

    if (diffInDays === 0) return "Posted today";
    if (diffInDays === 1) return "Posted yesterday";
    return `Posted ${diffInDays} days ago`;
  };

  return (
    <div className="job-card">
      <div className="job-card-header">
        <img src={job.logo} alt={job.company} className="job-logo" />
        <button className={`save-btn ${saved ? "saved" : ""}`} onClick={toggleSaveJob}>
          {saved ? "⭐ Saved" : "☆ Save"}
        </button>
      </div>
      
      <h3>{job.title}</h3>
      <p className="company">{job.company} • {job.location}</p>
      <p className="salary">💰 {job.salary}</p>
      <p className="posted-time">📅 {getPostedTime(job.posted)}</p>

      <div className="job-card-buttons">
        <Link to={`/jobs/${job.id}`} className="more-info-btn">More Info</Link>
        <Link to={`/jobs/${job.id}`} className="apply-btn">Apply Now</Link>
      </div>
    </div>
  );
};

export default JobCard;


// import React from "react";
// import "../styles/JobCard.css";

// const JobCard = ({ job }) => {
//   return (
//     <div className="job-card">
//       <h2>{job.title}</h2>
//       <p>{job.company} - {job.location}</p>
//       <p><strong>Salary:</strong> {job.salary}</p>
//       <button>Apply Now</button>
//     </div>
//   );
// };

// export default JobCard;
